module.exports = __webpack_public_path__ + "img/Abschnittsführungsstelle.3b206af2.svg";